module.exports = __webpack_public_path__ + "static/media/ic-price.c3b1b04d.svg";